import { render, staticRenderFns } from "./List.vue?vue&type=template&id=2c8aadf5&"
import script from "./List.vue?vue&type=script&lang=js&"
export * from "./List.vue?vue&type=script&lang=js&"
import style0 from "./List.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JG\\jg\\IWMS5.0\\SRM\\GIT\\SRM.VUE\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c8aadf5')) {
      api.createRecord('2c8aadf5', component.options)
    } else {
      api.reload('2c8aadf5', component.options)
    }
    module.hot.accept("./List.vue?vue&type=template&id=2c8aadf5&", function () {
      api.rerender('2c8aadf5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DeliveryNote/DnbarcodeHandmadeOutBox/List.vue"
export default component.exports